<script lang="ts">
  import {
    fetchAnnouncement,
    type Announcement,
    type AnnouncementResponse,
  } from "$lib/utils/fetchAnnouncement";
  import { PortableText } from "@portabletext/svelte";
  import theTime from "$lib/utils/the-time";
  import { onMount } from "svelte";

  const shouldShow = (announcement: Announcement) => {
    if (announcement?.active) {
      const time = theTime();
      const outsideAnnoucementWindow =
        (announcement.from && time < theTime(announcement.from)) ||
        (announcement.to && time > theTime(announcement.to));
      return !outsideAnnoucementWindow;
    }
  };

  let result: undefined | AnnouncementResponse = $state();

  onMount(async () => {
    result = await fetchAnnouncement();
  });
</script>

{#if result?.data && shouldShow(result.data)}
  <div class="wrapper mb-4">
    <div class="bg-$warning-400 px-edge-x">
      {#each result.data.announcement as a (a)}
        <PortableText value={a} />
      {/each}
    </div>
  </div>
{/if}

<style lang="postcss">
  .wrapper {
    animation: grow-down var(--easing) var(--duration, 0.5s) forwards;
    display: grid;

    > div {
      overflow: hidden;
    }
  }

  @keyframes grow-down {
    from {
      grid-template-rows: 0fr;
    }
    to {
      grid-template-rows: 1fr;
    }
  }
</style>
